export default "__VITE_ASSET__11b2f5b1__"